import { useFeature } from '@pcln/feature-components'
import { A, HorizonIcon, StatusBanner } from '@pcln/horizon'
import { useEffect } from 'react'

import { fireVacationVibeEntryClick, fireVacationVibeEntryDisplay } from '../ga4'

const DEFAULT_HEADING = "Tell us your vibe. We'll tell you where."
const DEFAULT_CAPTION = 'AI-powered trip inspiration with package deals built-in.'
const CTA_LABEL = 'Start exploring'
const CTA_HREF = '/journey/vacay-vibes'

function textOrFallback(value: unknown, fallback: string) {
  return typeof value === 'string' && value.trim() !== '' ? value : fallback
}

function bannerCopy(value: unknown) {
  const header = value && typeof value === 'object' && 'header' in value ? value.header : undefined
  const caption = value && typeof value === 'object' && 'caption' in value ? value.caption : undefined
  return {
    heading: textOrFallback(header, DEFAULT_HEADING),
    caption: textOrFallback(caption, DEFAULT_CAPTION),
  }
}

/** StatusBanner rewrites the CTA node to tertiary and clears className. Keep the link nested so the white pill stays. */
function StartExploringCta({ onClick }: Readonly<{ onClick: () => void }>) {
  return (
    <span>
      <A
        href={CTA_HREF}
        size='sm'
        type='secondary'
        emphasis='medium'
        target='_blank'
        rel='noopener noreferrer'
        onClick={onClick}
      >
        {CTA_LABEL}
      </A>
    </span>
  )
}

type VacationVibeEntryBannerProps = Readonly<{
  pageName: 'homepage' | 'landing'
}>

export function VacationVibeEntryBanner({ pageName }: VacationVibeEntryBannerProps) {
  const { heading, caption } = bannerCopy(useFeature('pkgSearch.vacationVibeBannerCopy'))

  useEffect(() => {
    fireVacationVibeEntryDisplay(pageName)
  }, [pageName])

  return (
    <StatusBanner
      headingNode={heading}
      captionNode={caption}
      iconNode={<HorizonIcon name='AiSearch' size='20' aria-hidden='true' />}
      slots={{
        baseSlot: 'border-transparent bg-highlight-3',
        iconSlot: 'bg-transparent *:text-neutral-13',
      }}
      primaryCtaNode={
        <StartExploringCta
          onClick={() => {
            fireVacationVibeEntryClick(pageName)
          }}
        />
      }
    />
  )
}
